export default {"src":"/_next/static/media/General-badge.403545d1.svg","height":46,"width":46};